
export enum LedStatus
{
    Start = "start",
    Work = "work",
    Halt = "halt",
    Idle = "idle",
    Fatal = "fatal",
    Error = "error",
}
